import React, { useEffect } from 'react';
import PremiumWizard from './components/PremiumWizard';
import './App.css';

function App() {
  useEffect(() => {
    const sendHeight = () => {
      const container = document.getElementById('app-container');
      if (container) {
        // Measure the actual visible content height
        const height = container.scrollHeight;
        window.parent.postMessage({ frameHeight: height }, "*");
      }
    };

    // Run immediately and on changes
    sendHeight();
    
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sendHeight, 100);
    };

    window.addEventListener('resize', handleResize);
    
    // Observer for dynamic content changes
    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', () => setTimeout(sendHeight, 300));

    return () => {
      window.removeEventListener('resize', handleResize);
      observer.disconnect();
    };
  }, []);

  return (
    // Reduced padding-bottom to prevent modal centering issues in iframes
    <div id="app-container" className="w-full h-auto bg-[#0a0a0a] pb-20 overflow-hidden">
      <PremiumWizard />
    </div>
  );
}

export default App;